<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Confirm',
    },
    message: {
      type: String,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<template>
  <v-dialog
    :value="dialog"
    :max-width="300"
    persistent
    :content-class="$style.dialogContainer"
    @keydown.esc="confirm"
  >
    <v-card rounded="xl">
      <v-toolbar color="primary" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4"
        ><h5>{{ message }}</h5></v-card-text
      >
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click.native="confirm">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
.dialogContainer {
  border-radius: 24px !important;
}
</style>
